var elementTools = require("../../../webvowl/util/elementTools")();


module.exports = function () {

	var filter = {},
		nodes,
		properties,
		enabled = false,
		filteredNodes,
		filteredProperties,
		filterSettings=[], 	//Настройки фильтров
		uriEnabled={};  		//URI c флагами включены/выключены


	/**
	 * If enabled, all object properties and things without any other property are filtered.
	 * @param untouchedNodes
	 * @param untouchedProperties
	 */
	filter.filter = function (untouchedNodes, untouchedProperties) {
		//console.log("objectPropertyFilter.js filter", untouchedNodes, untouchedProperties, uriEnabled);
		nodes = untouchedNodes;
		properties = untouchedProperties;

		if (this.enabled()) {
			removeObjectProperties();
		}

		if (filterSettings.length>0){
			removeFilteredObjectProperties();
		}

		filteredNodes = nodes;
		filteredProperties = properties;
	};

	function removeObjectProperties() {
		properties = properties.filter(isNoObjectProperty);
		nodes = nodes.filter(isNoFloatingThing);
	}

	function isNoObjectProperty(property) {
		return !elementTools.isObjectProperty(property);
	}

	function isNoFloatingThing(node) {
		var isNoThing = !elementTools.isThing(node);
		var hasNonFilteredProperties = hasPropertiesOtherThanObjectProperties(node, properties);
		return isNoThing || hasNonFilteredProperties;
	}

	function hasPropertiesOtherThanObjectProperties(node, properties) {
		for (var i = 0; i < properties.length; i++) {
			var property = properties[i];
			if (property.domain() !== node && property.range() !== node) {
				continue;
			}

			if (isNoObjectProperty(property)) {
				return true;
			}
		}

		return false;
	}

	function removeFilteredObjectProperties() {
		properties = properties.filter(isNoInFilterObjectProperty);
	}

	function isNoInFilterObjectProperty(property) {
		//console.log("objectPropertyFilter.js filter", property, property.iri(), property.id(), property.label());
		return !elementTools.isObjectProperty(property) || uriEnabled[property.iri()] != true;
	}

	filter.enabled = function (p) {
		if (!arguments.length) return enabled;
		enabled = p;
		return filter;
	};


	// Functions a filter must have
	filter.filteredNodes = function () {
		return filteredNodes;
	};

	filter.filteredProperties = function () {
		return filteredProperties;

	};

	/** Установка параметров фильтров  */
  filter.setFilterSettings=function(settings){
		filterSettings = [];
    const conversionSettings = (settings)?JSON.parse(JSON.stringify(settings)):{};
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.filters)
			filterSettings = conversionSettings.settings.extra_options.filters.filter(filter => filter.uri);
		uriEnabled = {};
		filterSettings.map(filter => uriEnabled[filter.uri] = "TRUE" === filter.hide.toUpperCase());
		//console.log("objectPropertyFilter.js  filter.setFilterSettings", filterSettings, uriEnabled);
	};

	filter.menuFilter = function () {
		return filterSettings;
	};

	filter.uriEnabled = function (uri, p=undefined) {
		if (p === undefined)
			return uriEnabled.hasOwnProperty(uri) ?  uriEnabled[uri] : true
		if (uriEnabled.hasOwnProperty(uri)){
			uriEnabled[uri] = p;
		}
		return filter;
	};

	return filter;
};
